module.exports = __webpack_public_path__ + "img/liberdade.4a94e649.png";